import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

// GET API: Fetch all tasks for a coach
export const fetchTodoTasksApi = async (coachId) => {
  try {
    const systemDate = new Date().toISOString().split('T')[0];
    const response = await axiosInstance.get(
        `${Endpoints.GET_TODO_TASKS_FOR_COACH}/${coachId}/${systemDate}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch To-Do tasks");
  }
};

// Delete Todo Task

export const deleteTodoTasksApi = async (taskId) => {
  try {
    const response = await axiosInstance.delete(
      `${Endpoints.DELETE_TODO_TASK}?taskId=${taskId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to Delete To-Do tasks");
  }
};

// The POST and UPDATE functions remain unchanged
export const createTodoTaskApi = async (taskPayload) => {
  try {
    const response = await axiosInstance.post(
      Endpoints.CREATE_TODO_TASK,
      taskPayload
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to create To-Do task");
  }
};

export const updateTodoTaskApi = async (taskPayload) => {
  try {
    const response = await axiosInstance.post(
      Endpoints.UPDATE_TODO_TASK,
      taskPayload
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to update To-Do task");
  }
};

export const updateTaskStatusApi = async (taskStatusPayload) => {
  try {
    const response = await axiosInstance.put(
      Endpoints.UPDATE_TODO_TASK_STATUS,
      taskStatusPayload
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to update task status");
  }
};
